export default __webpack_public_path__ + "static/media/ba11.4283d310.jpg";